import React from 'react';
import type { TemplateTargetKeys, Channel, BlastVariantTarget, DripStepTarget } from '../../types';
import ReadOnlyBlockEditor from './ReadOnlyBlockEditor';
import BlastTemplateLoader from './BlastTemplateLoader';
import DripTemplateLoader from './DripTemplateLoader';
type Props = {
    target: TemplateTargetKeys;
    channel: Channel;
    readOnly?: boolean;
    subject?: string;
    // Parent audience kind; the BE validate needs it to accept role/prospect variables.
    targetKind?: string | null;
    workspace?: boolean;
};
const BlockEditor: React.FC<Props> = ({
    target,
    channel,
    readOnly = false,
    subject,
    targetKind,
    workspace
}) => {
    if (target.target_type === 'blast_variant') {
        return (
            <BlastTemplateLoader
                target={target as BlastVariantTarget}
                channel={channel}
                readOnly={readOnly}
                targetKind={targetKind}
                workspace={workspace}
            />
        );
    }
    if (readOnly) {
        return (
            <ReadOnlyBlockEditor
                target={target}
                channel={channel}
                subject={subject}
                targetKind={targetKind}
            />
        );
    }
    return (
        <DripTemplateLoader
            target={target as DripStepTarget}
            channel={channel}
            targetKind={targetKind}
            workspace={workspace}
        />
    );
};
export default BlockEditor;
